import { _ctmAxios } from "@/plugins/ctmAxios";

const getCtmSugangStatus = (code) => {
  return _ctmAxios.get(`rest/external/mainStatus?code=${code}`);
};

const getApplicationInfo = (code) => {
  return _ctmAxios.get(`/rest/external/getSugangApplicationInfo`, {
    params: {
      code,
    },
  });
};

const getSugangLecture = (code) => {
  return _ctmAxios.get(`/rest/external/getSugangLecture`, {
    params: {
      code,
    },
  });
};

const saveRegisterAdd = (body) => {
  return _ctmAxios.post(`/rest/external/registerAdd`, body);
};

const saveRegisterPayAddTemp = (body) => {
  return _ctmAxios.post(`/rest/external/registerAddTossTemp`, body);
};

const saveRegisterPayAdd = (body) => {
  return _ctmAxios.post(`/rest/external/registerAddToss`, body);
};

const cancelClass = (idx) => {
  return _ctmAxios.post(`/rest/external/cancelApply?idx=${idx}`);
};
const ctmCancelClass = (idx) => {
  return _ctmAxios.post(`/rest/external/cancelApply?idx=${idx}`);
};
const blackList = (param) => {
  return _ctmAxios.get(`/rest/external/checkBlackList`, { params: param });
};

const dupApply = (param) => {
  return _ctmAxios.get(`/rest/lecture/check_dup_apply`, { params: param });
};

const applyHistoryList = (param) => {
  console.log(param);
  return _ctmAxios.get(`/rest/external/getSugangApplyHistory`, {
    params: param,
  });
};
export {
  getCtmSugangStatus,
  getApplicationInfo,
  getSugangLecture,
  saveRegisterAdd,
  saveRegisterPayAdd,
  saveRegisterPayAddTemp,
  cancelClass,
  blackList,
  dupApply,
  applyHistoryList,
  ctmCancelClass,
};
